var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"principal"},[(_vm.totalization.length == 0)?_c('div',[_c('span',{staticClass:"title"},[_vm._v("Nenhum registro encontrado!")])]):_c('TableTotalization',{attrs:{"totalization":_vm.totalization}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }